import type { AxModelInfo } from '../types.js';

import { AxAIAnthropicModel, AxAIAnthropicVertexModel } from './types.js';

export const axModelInfoAnthropic: AxModelInfo[] = [
  // 5 Sonnet (2026-06)
  {
    name: AxAIAnthropicModel.Claude5Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 2.0,
    completionTokenCostPer1M: 10.0,
    cacheReadTokenCostPer1M: 0.2,
    cacheWriteTokenCostPer1M: 2.5,
    maxTokens: 128000,
    contextWindow: 1_000_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude5Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 2.0,
    completionTokenCostPer1M: 10.0,
    cacheReadTokenCostPer1M: 0.2,
    cacheWriteTokenCostPer1M: 2.5,
    maxTokens: 128000,
    contextWindow: 1_000_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  // 4.8 Opus (2026-05)
  {
    name: AxAIAnthropicModel.Claude48Opus,
    currency: 'usd',
    promptTokenCostPer1M: 5.0,
    completionTokenCostPer1M: 25.0,
    cacheReadTokenCostPer1M: 0.5,
    cacheWriteTokenCostPer1M: 6.25,
    fastPromptTokenCostPer1M: 10.0,
    fastCompletionTokenCostPer1M: 50.0,
    fastCacheReadTokenCostPer1M: 1.0,
    fastCacheWriteTokenCostPer1M: 12.5,
    maxTokens: 128000,
    contextWindow: 1_000_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude48Opus,
    currency: 'usd',
    promptTokenCostPer1M: 5.0,
    completionTokenCostPer1M: 25.0,
    cacheReadTokenCostPer1M: 0.5,
    cacheWriteTokenCostPer1M: 6.25,
    maxTokens: 128000,
    contextWindow: 1_000_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  // 4.7 Opus (2026-03)
  {
    name: AxAIAnthropicModel.Claude47Opus,
    currency: 'usd',
    promptTokenCostPer1M: 5.0,
    completionTokenCostPer1M: 25.0,
    cacheReadTokenCostPer1M: 0.5,
    cacheWriteTokenCostPer1M: 6.25,
    fastPromptTokenCostPer1M: 30.0,
    fastCompletionTokenCostPer1M: 150.0,
    fastCacheReadTokenCostPer1M: 3.0,
    fastCacheWriteTokenCostPer1M: 37.5,
    maxTokens: 128000,
    contextWindow: 1_000_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude47Opus,
    currency: 'usd',
    promptTokenCostPer1M: 5.0,
    completionTokenCostPer1M: 25.0,
    cacheReadTokenCostPer1M: 0.5,
    cacheWriteTokenCostPer1M: 6.25,
    maxTokens: 128000,
    contextWindow: 1_000_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  // 4.6 Opus (2026-02)
  {
    name: AxAIAnthropicModel.Claude46Opus,
    currency: 'usd',
    promptTokenCostPer1M: 5.0,
    completionTokenCostPer1M: 25.0,
    cacheReadTokenCostPer1M: 0.5,
    cacheWriteTokenCostPer1M: 6.25,
    fastPromptTokenCostPer1M: 30.0,
    fastCompletionTokenCostPer1M: 150.0,
    fastCacheReadTokenCostPer1M: 3.0,
    fastCacheWriteTokenCostPer1M: 37.5,
    maxTokens: 128000,
    contextWindow: 1_000_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude46Opus,
    currency: 'usd',
    promptTokenCostPer1M: 5.0,
    completionTokenCostPer1M: 25.0,
    cacheReadTokenCostPer1M: 0.5,
    cacheWriteTokenCostPer1M: 6.25,
    maxTokens: 128000,
    contextWindow: 1_000_000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  // 4.6 Sonnet (2026-02)
  {
    name: AxAIAnthropicModel.Claude46Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 64000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude46Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 64000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  // 4.5 Opus (2025-11)
  {
    name: AxAIAnthropicModel.Claude45Opus,
    currency: 'usd',
    promptTokenCostPer1M: 5.0,
    completionTokenCostPer1M: 25.0,
    cacheReadTokenCostPer1M: 0.5,
    cacheWriteTokenCostPer1M: 6.25,
    maxTokens: 64000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude45Opus,
    currency: 'usd',
    promptTokenCostPer1M: 5.0,
    completionTokenCostPer1M: 25.0,
    cacheReadTokenCostPer1M: 0.5,
    cacheWriteTokenCostPer1M: 6.25,
    maxTokens: 64000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  // 4.5 Sonnet (2025-09)
  {
    name: AxAIAnthropicModel.Claude45Sonnet,
    currency: 'usd',
    // Estimated/prior pricing aligned with Sonnet tier
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 200000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude45Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 200000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  // 4.5 Haiku (2025-10)
  {
    name: AxAIAnthropicModel.Claude45Haiku,
    currency: 'usd',
    // Pricing per Anthropic announcement: $1 input / $5 output per 1M tokens
    promptTokenCostPer1M: 1.0,
    completionTokenCostPer1M: 5.0,
    cacheReadTokenCostPer1M: 0.1,
    cacheWriteTokenCostPer1M: 1.25,
    maxTokens: 200000, // match modern context window similar to Sonnet 4.5 era
    supported: { thinkingBudget: true, showThoughts: true },
  },
  {
    name: AxAIAnthropicVertexModel.Claude45Haiku,
    currency: 'usd',
    promptTokenCostPer1M: 1.0,
    completionTokenCostPer1M: 5.0,
    cacheReadTokenCostPer1M: 0.1,
    cacheWriteTokenCostPer1M: 1.25,
    maxTokens: 200000,
    supported: { thinkingBudget: true, showThoughts: true },
  },
  // 4
  {
    name: AxAIAnthropicModel.Claude41Opus,
    currency: 'usd',
    promptTokenCostPer1M: 15.0,
    completionTokenCostPer1M: 75.0,
    cacheReadTokenCostPer1M: 1.5,
    cacheWriteTokenCostPer1M: 18.75,
    maxTokens: 32000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude41Opus,
    currency: 'usd',
    promptTokenCostPer1M: 15.0,
    completionTokenCostPer1M: 75.0,
    cacheReadTokenCostPer1M: 1.5,
    cacheWriteTokenCostPer1M: 18.75,
    maxTokens: 32000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicModel.Claude4Opus,
    currency: 'usd',
    promptTokenCostPer1M: 15.0,
    completionTokenCostPer1M: 75.0,
    cacheReadTokenCostPer1M: 1.5,
    cacheWriteTokenCostPer1M: 18.75,
    maxTokens: 32000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude4Opus,
    currency: 'usd',
    promptTokenCostPer1M: 15.0,
    completionTokenCostPer1M: 75.0,
    cacheReadTokenCostPer1M: 1.5,
    cacheWriteTokenCostPer1M: 18.75,
    maxTokens: 32000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicModel.Claude4Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 64000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude4Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 64000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  // 3.7
  {
    name: AxAIAnthropicModel.Claude37Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 64000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicVertexModel.Claude37Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 64000,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  // 3.5
  {
    name: AxAIAnthropicModel.Claude35Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 8192,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIAnthropicVertexModel.Claude35Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 8192,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIAnthropicVertexModel.Claude35SonnetV2,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 8192,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIAnthropicModel.Claude35Haiku,
    currency: 'usd',
    promptTokenCostPer1M: 0.8,
    completionTokenCostPer1M: 4.0,
    cacheReadTokenCostPer1M: 0.08,
    cacheWriteTokenCostPer1M: 1.0,
    maxTokens: 8192,
  },
  {
    name: AxAIAnthropicVertexModel.Claude35Haiku,
    currency: 'usd',
    promptTokenCostPer1M: 1.0,
    completionTokenCostPer1M: 5.0,
    cacheReadTokenCostPer1M: 0.1,
    cacheWriteTokenCostPer1M: 1.25,
    maxTokens: 8192,
  },
  // 3
  {
    name: AxAIAnthropicModel.Claude3Opus,
    currency: 'usd',
    promptTokenCostPer1M: 15.0,
    completionTokenCostPer1M: 75.0,
    cacheReadTokenCostPer1M: 1.5,
    cacheWriteTokenCostPer1M: 18.75,
    maxTokens: 4096,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIAnthropicVertexModel.Claude3Opus,
    currency: 'usd',
    promptTokenCostPer1M: 15.0,
    completionTokenCostPer1M: 75.0,
    cacheReadTokenCostPer1M: 1.5,
    cacheWriteTokenCostPer1M: 18.75,
    maxTokens: 4096,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIAnthropicModel.Claude3Sonnet,
    currency: 'usd',
    promptTokenCostPer1M: 3.0,
    completionTokenCostPer1M: 15.0,
    cacheReadTokenCostPer1M: 0.3,
    cacheWriteTokenCostPer1M: 3.75,
    maxTokens: 4096,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIAnthropicModel.Claude3Haiku,
    currency: 'usd',
    promptTokenCostPer1M: 0.25,
    completionTokenCostPer1M: 1.25,
    cacheReadTokenCostPer1M: 0.03,
    cacheWriteTokenCostPer1M: 0.3,
    maxTokens: 4096,
  },
  {
    name: AxAIAnthropicVertexModel.Claude3Haiku,
    currency: 'usd',
    promptTokenCostPer1M: 0.25,
    completionTokenCostPer1M: 1.25,
    cacheReadTokenCostPer1M: 0.03,
    cacheWriteTokenCostPer1M: 0.3,
    maxTokens: 4096,
  },
  // 2.1
  {
    name: AxAIAnthropicModel.Claude21,
    currency: 'usd',
    promptTokenCostPer1M: 8.0,
    completionTokenCostPer1M: 25,
    maxTokens: 4096,
  },
  {
    name: AxAIAnthropicModel.ClaudeInstant12,
    currency: 'usd',
    promptTokenCostPer1M: 0.8,
    completionTokenCostPer1M: 2.24,
    maxTokens: 4096,
  },
];
